import React from 'react';
import CourseDetailTemplate from '../components/course/CourseDetailTemplate';
import { coursesData } from '../data/coursesData';
const Course2Page = () => {
  return <CourseDetailTemplate courseData={coursesData[2]} data-id="element-2340" />;
};
export default Course2Page;